/**
 * Entry application component used to compose providers and render Routes.
 * */
import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AuthInit } from "./modules/Auth";
// import { Routes } from "../app/Routes";
import Routes from "../app/Routes";
import { I18nProvider } from "../_metronic/i18n";
import "./app.css";
import "./google-font.css";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import { setConfigDataFromFile } from "../services/config";

export default function App({ store, persistor, basename }) {
  useEffect(() => {
    // Fetch config and update theme
    setConfigDataFromFile((newConfig) => {
      // Set CSS variables dynamically
      document.documentElement.style.setProperty(
        "--primary-btn-color",
        newConfig.btnColor
      );
      document.documentElement.style.setProperty(
        "--primary-txt-color",
        newConfig.txtColor
      );
      document.documentElement.style.setProperty(
        "--sidebar-background-color",
        newConfig.sideBarBgColor
      );
      document.documentElement.style.setProperty(
        "--sidebar-hover-color",
        newConfig.sideBarHoverColor
      );
      document.documentElement.style.setProperty(
        "--navbar-color",
        newConfig.navBarColor
      );
    });
  }, []);

  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<LayoutSplashScreen />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            <MaterialThemeProvider>
              {/* Provide `react-intl` context synchronized with Redux state.  */}
              <I18nProvider>
                {/* Render routes with provided `Layout`. */}
                <AuthInit>
                  <Routes />
                </AuthInit>
              </I18nProvider>
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
